import characterType1 from 'assets/images/summary/first-look/character_vag_1.svg';
import characterType2 from 'assets/images/summary/first-look/character_vag_2.svg';
import characterType3 from 'assets/images/summary/first-look/character_vag_3.svg';
import characterType4 from 'assets/images/summary/first-look/character_vag_4.svg';
import characterType4c0 from 'assets/images/summary/first-look/character_vag_4c0.svg';
import characterType4c1 from 'assets/images/summary/first-look/character_vag_4c1.svg';
import characterType4c2 from 'assets/images/summary/first-look/character_vag_4c2.svg';
import characterType4c3 from 'assets/images/summary/first-look/character_vag_4c3.svg';
import characterType4c4 from 'assets/images/summary/first-look/character_vag_4c4.svg';
import characterType5 from 'assets/images/summary/first-look/character_vag_5.svg';
import characterTypeOther from 'assets/images/summary/first-look/character_vag_other.svg';
import { GutTypeValue } from './gutTypes';

type VagTypeKey =
  | '1'
  | '1*'
  | '2'
  | '2*'
  | '3'
  | '3*'
  | '4a'
  | '4b'
  | '4c0'
  | '4c1'
  | '4c2'
  | '4c3'
  | '4c4'
  | '5'
  | 'other'
  | 'other lactobacillus';

const TYPE_1: GutTypeValue = {
  type: '1',
  characterImage: characterType1,
  shortDescription: 'The Guardian',
  longDescription:
    "Dominated by Lactobacillus crispatus, this type creates a protective, acidic environment that helps keep disruptive microbes away. During pregnancy, it's linked to a lower risk of preterm birth.",
  extraBackgroundClass: 'microbiome-type-vaginal',
};

const TYPE_2: GutTypeValue = {
  type: '2',
  characterImage: characterType2,
  shortDescription: 'The Strong Foundation',
  longDescription:
    'A stable community dominated by Lactobacillus gasseri, associated with lower risks of STIs and preterm birth during pregnancy.',
  extraBackgroundClass: 'microbiome-type-vaginal',
};

const TYPE_3: GutTypeValue = {
  type: '3',
  characterImage: characterType3,
  shortDescription: 'The Shapeshifter',
  longDescription:
    'Dominated by Lactobacillus iners, this common and generally healthy type may be less stable over time.',
  extraBackgroundClass: 'microbiome-type-vaginal',
};

const VAG_TYPES: Record<VagTypeKey, GutTypeValue> = {
  '1': TYPE_1,
  '1*': TYPE_1,
  '2': TYPE_2,
  '2*': TYPE_2,
  '3': TYPE_3,
  '3*': TYPE_3,
  '4a': {
    type: '4A',
    characterImage: characterType4,
    shortDescription: 'The Prickly One',
    longDescription:
      'A diverse, non-Lactobacillus community with higher levels of pro-inflammatory bacteria. This type is linked to bacterial vaginosis, reduced fertility, and preterm birth risk.',
    extraBackgroundClass: 'microbiome-type-vaginal',
  },
  '4b': {
    type: '4B',
    characterImage: characterType4,
    shortDescription: 'The Prickly One',
    longDescription:
      'This type is strongly linked to bacterial vaginosis (BV), infertility, and preterm birth. It features high Gardnerella vaginalis and BV-associated bacteria like BVAB1, Fannyhessea vaginae, and Prevotella. ',
    extraBackgroundClass: 'microbiome-type-vaginal',
  },
  '4c0': {
    type: '4C0',
    characterImage: characterType4c0,
    shortDescription: 'The Wildcard',
    longDescription:
      'A diverse community with many different bacteria, often including Prevotella. This type has been linked to bacterial vaginosis.',
    extraBackgroundClass: 'microbiome-type-vaginal',
  },
  '4c1': {
    type: '4C1',
    characterImage: characterType4c1,
    shortDescription: 'The Double Agent',
    longDescription:
      'While it can support an acidic environment, this Streptococcus-dominated community carries a higher risk of aerobic vaginitis, UTIs, and preterm birth.',
    extraBackgroundClass: 'microbiome-type-vaginal',
  },
  '4c2': {
    type: '4C2',
    characterImage: characterType4c2,
    shortDescription: 'The Troublemaker',
    longDescription:
      'This type has high levels of Enterococcus, which have been linked to aerobic vaginitis and urinary tract infections.',
    extraBackgroundClass: 'microbiome-type-vaginal',
  },
  '4c3': {
    type: '4C3',
    characterImage: characterType4c3,
    shortDescription: 'The Lifegiver',
    longDescription:
      'Rich in Bifidobacterium, this type helps protect against infection–though not as strongly as Lactobacillus. During pregnancy, it may help give your baby’s microbiome a healthy head start at birth.',
    extraBackgroundClass: 'microbiome-type-vaginal',
  },
  '4c4': {
    type: '4C4',
    characterImage: characterType4c4,
    shortDescription: 'The Disrupter',
    longDescription:
      'Marked by high levels of Staphylococcus species, this type is associated with aerobic vaginitis and UTIs.',
    extraBackgroundClass: 'microbiome-type-vaginal',
  },
  '5': {
    type: '5',
    characterImage: characterType5,
    shortDescription: 'The Quiet Sentinel',
    longDescription:
      'Rare but healthy, this type dominated by Lactobacillus jensenii mantains a low pH that helps protect against infections and is linked to lower risk of preterm birth.',
    extraBackgroundClass: 'microbiome-type-vaginal',
  },
  other: {
    type: 'Other',
    characterImage: characterTypeOther,
    shortDescription: 'The Disrupter',
    longDescription:
      'Your community doesn’t fit into the main groups — and that’s okay. Every vaginal microbiome is unique, and there’s still so much science is discovering.',
    extraBackgroundClass: 'microbiome-type-vaginal',
  },
  'other lactobacillus': {
    type: 'Other Lactobacillus',
    characterImage: characterTypeOther,
    shortDescription: 'The Undiscovered',
    longDescription:
      'Your community is dominated by an uncommon Lactobacillus species — and that’s okay. Every vaginal microbiome is unique, and there’s still so much science is discovering.',
    extraBackgroundClass: 'microbiome-type-vaginal',
  },
};

export function getVagType(key: string): GutTypeValue {
  const found = VAG_TYPES[key as VagTypeKey];

  if (!found) {
    console.error(
      `No vaginal microbiome type with key "${key}" found, using default.`,
    );
    return VAG_TYPES['1'];
  }

  return found;
}
